// extracted by mini-css-extract-plugin
export default {"wrapper":"ReceiptProvidersListPreview_wrapper__-HrxP","header":"ReceiptProvidersListPreview_header__6aXFb"};